import { ReactTyped } from "react-typed";
import { Link } from "react-router-dom";

import MainLayout from "layouts/MainLayout";
import SplashCursor from "utils/SplashCursor";

const About = () => {
    return (
        <MainLayout>
            <SplashCursor />
            <div>
                <div className="main-content">
                    <div className="grid grid-cols-12">
                        <div className="col-span-12 md:col-start-2 md:col-span-5 px-6 md:px-0 mt-20 md:mt-0 md:h-[80vh] flex flex-col justify-center overflow-hidden">
                            <h1 className="text-7xl md:text-8xl font-evolventa font-bold tracking-tighter leading-[120%] text-pink-500">
                                Graphic Designer *
                            </h1>
                            <p>*Mainly a graphic designer. Read on for the tea!</p>
                            <p className="font-evolventa font-regular text-[1.2rem] tracking-normal mt-20 md:leading-[160%] ">
                                <span className="font-bold text-pink-500">tldr;</span> Over the past half decade, I have worked on
                                startups and corporations wearing many hats over the years - Designer, Devleoper,
                                Communications and even Assistant Lecturer for a while. Most proficient in creating
                                branding and marketing creatives. Always open to fresh and exciting projects.
                            </p>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 mt-40 md:mt-10 md:gap-2">
                        <div className="col-span-12 md:col-start-2 md:col-span-4 mx-auto mt-10 md:mt-0 md:h-[40vh] flex flex-col justify-end overflow-hidden">
                            <p className="font-evolventa font-regular text-xl tracking-tight mt-20 text-center font-bold">
                                Professionally, a designer and photographer
                            </p>
                            <p className="font-evolventa font-regular text-xl tracking-tight text-center mt-5">
                                Academically, a software engineer,
                            </p>
                            <p className="font-evolventa font-regular text-lg tracking-tight text-center">
                                Semi-professionally, a lecturer and mentor,
                            </p>
                            <p className="font-evolventa font-regular text-lg tracking-tight text-center">
                                Lovingly, a coffee enthusiast.
                            </p>
                            <p className="font-evolventa font-regular text-xl tracking-tight text-center mt-20">
                                A lot of hats over the years.
                            </p>
                        </div>
                        <div className="col-span-12 md:col-start-7 md:col-span-4 mx-auto mt-40 md:mt-0 md:h-[40vh] flex flex-col justify-end overflow-hidden">
                            <h1 className="text-7xl md:text-8xl font-evolventa font-bold tracking-tighter leading-[120%] text-center">
                                Sahir Prajapati
                            </h1>
                            <p className="text-center font-evolventa text-xl mt-10">
                                <span className="font-bold tracking-[10%] ">
                                    {" "}
                                    <ReactTyped
                                        strings={["Software Engineer", "Designer", "Developer", "Photographer"]}
                                        typeSpeed={100}
                                        loop
                                        backSpeed={20}
                                        cursorChar="<"
                                        showCursor={true}
                                    />
                                </span>{" "}
                            </p>
                        </div>

                        {/* Gap for the right side */}
                        <div className="hidden md:block col-span-2"></div>
                    </div>

                    <div className="grid grid-cols-12 md:mt-40 mt-10">
                        <div className="font-bold col-span-12 md:col-span-2 md:col-start-2 mx-auto mt-40 md:mt-0 md:h-[60vh] justify-center flex flex-col overflow-hidden md:text-3xl text-left md:leading-[200%] font-evolventa text-[2rem]">
                            NOT THE TLDR; DUH!
                        </div>
                        <div className="col-span-12 md:col-span-7 md:col-start-5 mx-5 mt-10 md:mt-0  tracking-normal justify-center flex flex-col overflow-hidden md:text-xl md:leading-[170%] leading-[199%] font-evolventa">
                            {" "}
                            <p className="text-[1.25rem]">
                                With more than five years of experience working across both startups and corporate environments, I specialize in graphic design with a focus on creating meaningful, results-driven visual experiences. My work spans branding, digital campaigns, social media strategy, website design, and print collateral, allowing me to help businesses communicate their story consistently across multiple platforms. I thrive in collaborative environments, working closely with marketing teams, stakeholders, and cross-functional partners to translate ideas into visually engaging campaigns that resonate with target audiences.

                                <br /><br />

                                Whether it’s developing a complete brand identity, designing impactful social media content, or optimizing website layouts for both aesthetics and accessibility, I approach each project with strategic thinking and creative problem-solving. Beyond design, I enjoy mentoring and guiding teams, streamlining workflows, and ensuring projects are delivered on time without compromising quality.

                                <br /><br />I’m passionate about projects that challenge creative boundaries and offer opportunities to experiment, innovate, and push the limits of visual storytelling. If you’re looking for someone to bring clarity, cohesion, and creativity to your brand, I’m ready to help elevate your ideas into designs that leave a lasting impact.

                                <br /><br />Also, if anyone is reading this and is hesitating to send an email or a DM at instagram, <Link to="mailto:info@sahirprajapati.com">JUST EMAIL</Link> something to me at <Link to="mailto:info@sahirprajapati.com" className="text-blue-500">hello@sahirprajapati.com</Link> or if that's a lot for you, send a message on instagram at <Link target="_blank" to="https://www.instagram.com/zennie.visuals" className="text-lg text-pink-500">@zennie.visuals</Link>, I'm as human as you are and I have learned random emails and messages works. at least with me, 99% of the time, it will work every time. As my favorite youtuber says, Say yes now, figure it out later. Worst case scenario, we end up JUST discussing on the project, otherwise let's build something awesome together!
                            </p>
                        </div>
                        {/* Gap for the right side */}
                        <div className="hidden md:block col-span-1"></div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}

export default About;